import {Dateformat} from "dateformat";

export class DateFormat{

  static getDate({zone = 7, format, date}){
    let now = new Date();
    if (date) {
      now = new Date(date);
    }
    now.setHours(now.getHours() + zone);
    return format ? Dateformat(now, format) : now;
  }

  static getTimeStamp(nextSeconds = 0){
    return (new Date()).getTime() + (nextSeconds * 1000);
  }

  static toTimeStamp(anyDate){
    return new Date(anyDate).getTime();
  }
}



